import React, { Component } from "react";
import VehicleReportTableDayContent from "./VehicleReportTableDayContent";
import styles from "./vehicleReportTable.module.scss";
import { v4 as uuidv4 } from "uuid";

class VehicleReportTableDaysContent extends Component {
  render() {
    const { days, openDashboards, handleClickRow, handlerRowClick, selectDate } = this.props;

    return days.map((day) => {
      return [
        <div key={uuidv4()} className={styles.reportTableDayContainer}>
          <b>{day.day}</b>
        </div>,
        <VehicleReportTableDayContent
          key={uuidv4()}
          day={day}
          selectDate={selectDate ?? days[0].rows[0].time}
          handleClickRow={handleClickRow}
          handlerRowClick={handlerRowClick}
          isDahsbordVisible={openDashboards.includes(day.day)}
          onOpenDashboard={this.props.onOpenDashboard}
          onCloseDashboard={this.props.onCloseDashboard}
        />,
      ];
    });
  }
}

export default VehicleReportTableDaysContent;
